import { Link } from 'react-router-dom';
import { getInitials, timeAgo } from '../../../utils/helpers';
import { Conversation } from '../../services/patientApi';

interface ItemProps {
  conv: Conversation;
  isSelected: boolean;
  to: string;
}

export const Item = ({ conv, isSelected, to }: ItemProps) => {
  const { title, state, last_non_internal_message } = conv.attributes;
  const msg = last_non_internal_message?.data?.attributes;

  return (
    <Link
      to={to}
      className={`block px-4 py-3 border-b border-gray-50 transition-colors border-l-2 ${
        isSelected ? 'bg-blue-50 border-l-teamcare-blue' : 'hover:bg-gray-50 border-l-transparent'
      }`}
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-teamcare-blue text-white flex items-center justify-center text-sm font-bold flex-shrink-0">
          {getInitials(title)}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-1">
            <span className="text-sm font-semibold text-secondary-900 truncate">{title}</span>
            {msg?.time && (
              <span className="text-xs text-secondary-400 flex-shrink-0 ml-2">{timeAgo(msg.time)}</span>
            )}
          </div>
          {msg && (
            <p className="text-xs text-secondary-500 truncate">
              {!msg.from_patient && <span className="font-bold text-secondary-700">You: </span>}
              {msg.content}
            </p>
          )}
          <span
            className={`inline-block mt-1.5 text-[10px] font-semibold px-1.5 py-0.5 rounded-md ${
              state === 'open' ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-700'
            }`}
          >
            {state}
          </span>
        </div>
      </div>
    </Link>
  );
};
